import { Injectable } from '@angular/core';

@Injectable()
export class TermsConditionsDocumentsService {
    protected readonly documentRoutes: Record<string, { part1: string; part2: string }> = {
        generalConditions: {
            part1: '/itxwebstandard/pdf/purchase_conditions/', part2: '/general_conditions',
        },
        privacyPolicy: {
            part1: '/itxwebstandard/pdf/privacy_policy/', part2: '/privacy_policy',
        },
        privacyPolicyPaymentKr: {
            part1: '/itxwebstandard/pdf/purchase_conditions/', part2: '/terms_nicepay',
        },
        giftCardConditions: {
            part1: 'itxwebstandard/pdf/termsandconditions_giftcard/', part2: '/termsandconditions',
        },
        cancelationPolicies: {
            part1: '/itxwebstandard/pdf/cancelation_right/', part2: '/cancelation_right',
        },
        feelTermsConditions: {
            part1: '/itxwebstandard/pdf/terms_conditions_feel/', part2: '/terms_conditions_feel',
        },
        feelTermsConditionsChina: {
            part1: '/itxwebstandard/pdf/feel_conditions/', part2: '/feel_conditions',
        },
        feelPrivacyPolicy: {
            part1: '/itxwebstandard/pdf/privacy_policy_feel/', part2: '/privacy_policy_feel',
        },
        feelPrivacyPolicyChina: {
            part1: '/itxwebstandard/pdf/privacy_policy/', part2: '/privacy_policy',
        },
        ticketlessTermsConditions: {
            part1: '/itxwebstandard/pdf/purchase_conditions_app/', part2: '/general_conditions_app',
        },
    };

    public getDocumentRoute(name: string): { part1: string; part2: string } {
        return this.documentRoutes[name] || null;
    }
}
